import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export function useCheckout() {
  const [loading, setLoading] = useState(null);
  const start = async (planId) => {
    if (planId === "free") {
      toast.info("Ya estás en el plan Gratis.");
      return;
    }
    setLoading(planId);
    try {
      const { data } = await api.post("/billing/checkout", {
        plan_id: planId,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error iniciando checkout");
      setLoading(null);
    }
  };
  return { start, loading };
}

export function CheckoutButton({ planId, className, children, variant = "dark", ...props }) {
  const { start, loading } = useCheckout();
  const base = `font-mono-mark text-[11px] px-4 py-3 border flex items-center justify-center gap-2 ${className || ""}`;
  const styles = {
    dark: "bg-[#0A0A0A] text-white border-[#0A0A0A] hover:bg-[#E53935] hover:border-[#E53935]",
    red: "bg-[#E53935] text-white border-[#E53935]",
    outline: "bg-transparent text-[#0A0A0A] border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white",
  };
  return (
    <button
      onClick={() => start(planId)}
      disabled={loading === planId}
      className={`${base} ${styles[variant] || styles.dark}`}
      {...props}
    >
      {loading === planId ? <Loader2 className="w-4 h-4 animate-spin" /> : children}
    </button>
  );
}
